import { mapGetters } from "vuex";
import { DetectMobile } from "./../../../mixins/detectmobile";
export default {
  filters: {
    cut: function(value) {
      let n = 140;
      if (!value) return "";
      if (value.length <= n) return value;
      return value.substring(0, n) + "...";
    },
    cutgift: function(value) {
      let n = 50;
      if (!value) return "";
      if (value.length <= n) return value;
      return value.substring(0, n) + "...";
    },
    formatStatus(value, vueObj) {
      let that = vueObj;
      if (value && typeof(value) == "string")
        value = parseInt(value)
      let pricing;
      switch (value) {
        case 1:
          pricing = that.$t("message.new");
          break;
        case 2:
          pricing = that.$t("message.popular");
          break;
        case 3:
          pricing = that.$t("message.soldOut");
          break;
        default:
          pricing = "";
          break;
      }
      return pricing;
    },
  },
  computed: {
    ...mapGetters([
      "getUsedLifeStyles",
      "currencySign",
    ]),
    imageRatioStyle() {
      var styles = [];
      if (this.height > this.width) {
        styles = [
          { "background-size": "contain" },
          { "background-repeat": "no-repeat" },
          { "background-position": "center" },
        ];
      }
      return styles;
    },
    dialogImageRatioStyle() {
      var styles = [];
      if (this.height * 1.2 > this.width) {
        styles = [
          { "background-size": "contain" },
          { "background-repeat": "no-repeat" },
          { "background-position": "center" },
        ];
      }
      return styles;
    },
    dietaryList() {
      var that = this;
      var items = [];
      if (this.category.ProductAllergy)
        items = this.category.ProductAllergy.map((p) =>
          that.getUsedLifeStyles.allergies.find((s) => s.Id === p)
        ).filter((p) => p);
      if (this.category.ProductIntolerance)
        items = [
          ...items,
          ...this.category.ProductIntolerance.map((p) =>
            that.getUsedLifeStyles.intolerances.find((s) => s.Id === p)
          ).filter((p) => p),
        ];
      if (this.category.ProductPreference)
        items = [
          ...items,
          ...this.category.ProductPreference.map((p) =>
            that.getUsedLifeStyles.preferences.find((s) => s.Id === p)
          ).filter((p) => p),
        ];
      return items;
    },
  },
  methods: {
    showModal() {
      if (
        DetectMobile.methods.isMobile(true) &&
        this.$root &&
        this.$root.$refs && 
        this.$root.$refs.Productlist &&
        this.$root.$refs.Productlist.$refs &&
        this.$root.$refs.Productlist.$refs.scrollview
      ) {
        this.$root.$refs.Productlist.$refs.scrollview.style.position = "";
      }
      if (this.status === undefined) {
        this.isModalVisible = this.product.Status != 3 ;
      } else {
        this.isModalVisible = this.status != 3 ;
      }
    },
    closeModal() {
      if (
        DetectMobile.methods.isMobile(true) &&
        this.$root &&
        this.$root.$refs && 
        this.$root.$refs.Productlist &&
        this.$root.$refs.Productlist.$refs &&
        this.$root.$refs.Productlist.$refs.scrollview
      ) {
        this.$root.$refs.Productlist.$refs.scrollview.style.position = "fixed";
      }
  
      this.isModalVisible = false;
    },
    getImageWidthHeight() {
      if (this.product && this.product.PhotoUrl) {
        var image = new Image();
        image.src = this.product.PhotoUrl;
        var that = this;
        image.onload = function() {
          that.width = this.width;
          that.height = this.height;
        };
      }
    },
    getIconStyle(item) {
      if (item && item.Name)
        return [
          {
            "background-image": `url(https://abacus-assets.firebaseapp.com/onlineordering/images/dietary/icon/abacus_dietary_${item.Name.split(
              " "
            ).join("")}.png)`,
          },
        ];
      else return [];
    },
  },
};
